const state = {
  objektasID: null,
  hipotekaTipas: '',
  hipotekaBusena: '',
  hipotekaBusenaTolimesne: '',
  hipotekaReadonly: false,
  hipotekaOwner: false,
  pasirasymasVadovas: false,
  signStatus: false,
  objektasVeiksmas: null,
  objektasRusys: [],
  objektasSalyginis: null,
  perduodamasKreditoriui: null,
  dokumentasSavitarna: null,
  objektasSavitarna: null,
  turtasID: null,
  turtasRusis: null,
  prievoleID: null,
  vykdomasisID: null,
  checkErrors: null,
  registratoriaiAktyvus: null,
}

// getters
const getters = {
  objektasID: state => state.objektasID,
  hipotekaTipas: state => state.hipotekaTipas,
  hipotekaBusena: state => state.hipotekaBusena,
  hipotekaBusenaTolimesne: state => state.hipotekaBusenaTolimesne,
  hipotekaReadonly: state => state.hipotekaReadonly,
  hipotekaOwner: state => state.hipotekaOwner,
  pasirasymasVadovas: state => state.pasirasymasVadovas,
  signStatus: state => state.signStatus,
  objektasVeiksmas: state => state.objektasVeiksmas,
  objektasRusys: state => state.objektasRusys,
  objektasSalyginis: state => state.objektasSalyginis,
  perduodamasKreditoriui: state => state.perduodamasKreditoriui,
  dokumentasSavitarna: state => state.dokumentasSavitarna,
  objektasSavitarna: state => state.objektasSavitarna,
  turtasID: state => state.turtasID,
  turtasRusis: state => state.turtasRusis,
  vykdomasisID: state => state.vykdomasisID,
  prievoleID: state => state.prievoleID,
  checkErrors: state => state.checkErrors,
  showCheckErrors: state => state.checkErrors !== null,
  registratoriaiAktyvus: state => state.registratoriaiAktyvus,
}

// actions
const actions = {
  objektasID({ commit }, payload) {
    commit('objektasID', payload)
    sessionStorage.setItem(
      'objektasID',
      parseInt(payload) ? JSON.stringify(payload) : null
    )
  },
  hipotekaTipas({ commit }, payload) {
    commit('hipotekaTipas', payload)
    sessionStorage.setItem('hipotekaTipas', JSON.stringify(payload))
  },
  hipotekaBusena({ commit }, payload) {
    commit('hipotekaBusena', payload)
    sessionStorage.setItem('hipotekaBusena', JSON.stringify(payload))
  },
  hipotekaBusenaTolimesne({ commit }, payload) {
    commit('hipotekaBusenaTolimesne', payload)
    sessionStorage.setItem('hipotekaBusenaTolimesne', JSON.stringify(payload))
  },
  hipotekaReadonly({ commit }, payload) {
    commit('hipotekaReadonly', payload)
    sessionStorage.setItem('hipotekaReadonly', JSON.stringify(payload))
  },
  hipotekaOwner({ commit }, payload) {
    commit('hipotekaOwner', payload)
    sessionStorage.setItem('hipotekaOwner', JSON.stringify(payload))
  },
  pasirasymasVadovas({ commit }, payload) {
    commit('pasirasymasVadovas', payload)
    sessionStorage.setItem('pasirasymasVadovas', JSON.stringify(payload))
  },
  signStatus({ commit }, payload) {
    commit('signStatus', payload)
    sessionStorage.setItem('signStatus', JSON.stringify(payload))
  },
  objektasVeiksmas({ commit }, payload) {
    commit('objektasVeiksmas', payload)
    sessionStorage.setItem('objektasVeiksmas', JSON.stringify(payload))
  },
  objektasRusys({ commit }, payload) {
    commit('objektasRusys', payload)
    sessionStorage.setItem('objektasRusys', JSON.stringify(payload))
  },
  objektasSalyginis({ commit }, payload) {
    commit('objektasSalyginis', payload)
    sessionStorage.setItem('objektasSalyginis', JSON.stringify(payload))
  },
  perduodamasKreditoriui({ commit }, payload) {
    commit('perduodamasKreditoriui', payload)
    sessionStorage.setItem('perduodamasKreditoriui', JSON.stringify(payload))
  },
  dokumentasSavitarna({ commit }, payload) {
    commit('dokumentasSavitarna', payload)
    sessionStorage.setItem('dokumentasSavitarna', JSON.stringify(payload))
  },
  objektasSavitarna({ commit }, payload) {
    commit('objektasSavitarna', payload)
    sessionStorage.setItem('objektasSavitarna', JSON.stringify(payload))
  },
  turtasID({ commit }, payload) {
    commit('turtasID', payload)
    sessionStorage.setItem(
      'turtasID',
      parseInt(payload) ? JSON.stringify(payload) : null
    )
  },
  turtasRusis({ commit }, payload) {
    commit('turtasRusis', payload)
    sessionStorage.setItem('turtasRusis', JSON.stringify(payload))
  },
  vykdomasisID({ commit }, payload) {
    commit('vykdomasisID', payload)
    sessionStorage.setItem('vykdomasisID', JSON.stringify(payload))
  },
  prievoleID({ commit }, payload) {
    commit('prievoleID', payload)
    sessionStorage.setItem('prievoleID', JSON.stringify(payload))
  },
  checkErrors({ commit }, payload) {
    commit('checkErrors', payload)
  },
  registratoriaiAktyvus({ commit }, payload) {
    commit('registratoriaiAktyvus', payload)
  },
}

// mutations
const mutations = {
  objektasID(state, data) {
    state.objektasID = data
  },
  hipotekaTipas(state, data) {
    state.hipotekaTipas = data
  },
  hipotekaBusena(state, data) {
    state.hipotekaBusena = data
  },
  hipotekaBusenaTolimesne(state, data) {
    state.hipotekaBusenaTolimesne = data
  },
  hipotekaReadonly(state, data) {
    state.hipotekaReadonly = data
  },
  hipotekaOwner(state, data) {
    state.hipotekaOwner = data
  },
  pasirasymasVadovas(state, data) {
    state.pasirasymasVadovas = data
  },
  signStatus(state, data) {
    state.signStatus = data
  },
  objektasVeiksmas(state, data) {
    state.objektasVeiksmas = data
  },
  objektasRusys(state, data) {
    state.objektasRusys = data
  },
  objektasSalyginis(state, data) {
    state.objektasSalyginis = data
  },
  perduodamasKreditoriui(state, data) {
    state.perduodamasKreditoriui = data
  },
  dokumentasSavitarna(state, data) {
    state.dokumentasSavitarna = data
  },
  objektasSavitarna(state, data) {
    state.objektasSavitarna = data
  },
  turtasID(state, data) {
    state.turtasID = data
  },
  turtasRusis(state, data) {
    state.turtasRusis = data
  },
  vykdomasisID(state, data) {
    state.vykdomasisID = data
  },
  prievoleID(state, data) {
    state.prievoleID = data
  },
  checkErrors(state, data) {
    state.checkErrors = data
  },
  registratoriaiAktyvus(state, data) {
    state.registratoriaiAktyvus = data
  },
}

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations,
}
